<template>
  <div>
    <b-navbar toggleable="md" variant="dark" type="dark" fixed="top">
      <a href="/">
        <v-img
          class="mr-2 site-logo"
          src="/assets/images/logo.png"
          width="40"
          height="40"
          title="CitSci"
          alt="CitSci"
        ></v-img>
      </a>
      <b-navbar-brand href="/">
        CitSci
      </b-navbar-brand>

      <!-- Collapse Navbar for smaller-width screens -->
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="mr-auto">
          <b-nav-item-dropdown>
            <template slot="button-content">
              <span title="About Us">About</span>
            </template>
            <b-dropdown-item
              :to="{ name: 'About' }"
              alt="About Us"
              title="About Us"
            >About Us
            </b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'Impact' }"
              alt="Our Impact"
              title="Our Impact"
            >Our Impact
            </b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'Mission' }"
              alt="Mission"
              title="Mission"
            >Mission
            </b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'Staff' }"
              alt="Team"
              title="Team"
            >Team
            </b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'Partners' }"
              alt="Partners"
              title="Partners"
            >Partners
            </b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'Publications' }"
              alt="Publications"
              title="Publications"
            >Publications
            </b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'Faqs' }"
              alt="FAQS"
              title="FAQS"
            >FAQS
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item
            v-for="(tab, index) in mainNavigationTabs"
            :key="index"
            :to="tab.to"
            :alt="tab.title"
            :title="tab.title"
          >{{ tab.title }}
          </b-nav-item
          >
          <b-nav-item href="https://blog.citsci.org/">Blog</b-nav-item>
          <b-nav-item-dropdown>
            <template slot="button-content">
              <span title="More">More</span>
            </template>
            <b-dropdown-item
              :to="{ name: 'Features' }"
              alt="Features"
              title="Features"
            >Features
            </b-dropdown-item
            >
            <b-dropdown-item
              :to="{ name: 'Publications' }"
              alt="How to Cite"
              title="How to Cite"
            >How to Cite
            </b-dropdown-item
            >
            <b-dropdown-item
              :to="{ name: 'Developers' }"
              alt="Developers"
              title="Developers"
            >Developers
            </b-dropdown-item
            >
            <b-dropdown-item
              :to="{ name: 'Connect' }"
              alt="Connect"
              title="Connect"
            >Connect
            </b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="justify-center">
          <b-nav-item
            v-if="!isAuthenticated"
            alt="Sign Up"
            title="Sign Up"
            :to="{name: 'Register'}"
          >Sign Up
          </b-nav-item>
          <b-nav-item
            v-if="!isAuthenticated"
            alt="Login"
            title="Login"
            :to="{name: 'Login'}"
          >Login
          </b-nav-item>
          <b-nav-item-dropdown class="mr-2" text="My Projects" right v-if="isAuthenticated && userData">
            <h6 class="dropdown-header">Published Projects</h6>
            <b-dropdown-item
              v-if="projectsPublished.length > 0"
              v-for="projectItem in projectsPublished"
              :key="projectItem.projectId"
              :to="{ name: 'ProjectShow', params: { id: projectItem['projectUrl'] } }"
              active-class="no-active"
              :alt="projectItem.projectName"
              :title="projectItem.projectName"
            >
              <template v-if="projectItem.approved">
                {{ projectItem.projectName | shortText }}
              </template>
              <template v-else>
                {{ (projectItem.projectName + " (pending)") | shortText }}
              </template>
            </b-dropdown-item>

            <b-dropdown-item class="ml-3 mt-2 color-gray"
              v-if="projectsPublished.length === 0"
              alt="No published projects"
              title="No published projects"
            >
              No published projects
            </b-dropdown-item>

            <div class="dropdown-divider"></div>

            <h6 class="dropdown-header">Draft Projects</h6>
            <b-dropdown-item
              v-if="projectsDraft.length > 0"
              v-for="projectItem in projectsDraft"
              :key="projectItem.projectId"
              :to="{ name: 'ProjectShow', params: { id: projectItem['projectUrl'] } }"
              active-class="no-active"
              :alt="projectItem.projectName"
              :title="projectItem.projectName"
            >
              <template v-if="projectItem.approved">
                {{ projectItem.projectName | shortText }}
              </template>
              <template v-else>
                {{ (projectItem.projectName + " (pending)") | shortText }}
              </template>
            </b-dropdown-item>
            <div class="ml-3 mt-2" style="color:#22252C;"
                 v-if="projectsDraft.length === 0"
                 title="No published projects yet"
            >
              No draft projects
            </div>

            <div class="dropdown-divider"></div>
            <b-dropdown-item
              id="CreateProjectLink"
              title="Create New Project"
              alt="Create New Project"
              @click="onCreateClick"
            >
              <template> <b>Create New Project</b></template>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <NavNotifications class="ml-2 mr-2"
                            v-if="isAuthenticated && userData"></NavNotifications>
          <b-nav-item-dropdown text="My Account" right v-if="isAuthenticated && userData">
            <template slot="button-content">
              <span class='d-md-none d-lg-inline mr-2'>{{ displayName }}</span>
              <b-avatar size="sm" :src="avatar" class="profile-avatar"></b-avatar>
            </template>
            <b-dropdown-item
              :to="{ name: 'ProfileShow', }"
              alt="My Profile"
              title="My Profile">
              My Profile
            </b-dropdown-item>
            <b-dropdown-item v-if="isAdmin"
              :to="{ name: 'AdminShow' }"
              alt="Admin Dashboard"
              title="Admin Dashboard">
              Admin Dashboard
            </b-dropdown-item>
            <b-dropdown-item
              :to="{ name: 'Logout' }"
              alt="Logout"
              title="Logout">
              Logout
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item>
            <b-button-group size="sm">
              <b-button
                v-if="!currentRouteName.includes('/projects/space-cloud-watch')"
                class="btn-tertiary p-1 px-2 ml-2 border-1 border-white rounded-lg"
                active-class="no-active"
                :to="{ name: 'Donate' }"
                alt="Support CitSci"
                title="Support CitSci"
              >
                <font-awesome-icon icon="heart"/>
                <span class='d-md-none d-lg-inline ml-2'>Donate</span>
              </b-button>
              <b-button
                class='btn btn-info ml-2 p-1 px-2 rounded-lg text-white border-1 border-white bg-info'
                active-class="no-active"
                alt="Report CitSci Issues"
                title="Report CitSci Issues"
                @click=openCitSciHelp
              >
                <font-awesome-icon icon="question"/>
                <span class='d-md-none d-lg-inline ml-2'>Help</span>
              </b-button>
            </b-button-group>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'
import {PROJECT_STATE_PUBLISHED, PROJECT_STATE_DRAFT} from '../../constants/project_states'
import NavNotifications from './NavNotifications.vue'
import DonateButton from '../donate/DonateButton.vue'

export default {
  name: 'BootstrapVueNavbar',
  components: {
    NavNotifications,
    DonateButton,
  },

  data() {
    return {
      supportFormURL: 'https://docs.google.com/forms/d/e/1FAIpQLSc_K0CvacZRItpra4_O5npwjZZTYzAPHPidUxr4rVrDUf9EVg/viewform',
      mainNavigationTabs: [
        {to: {name: 'ProjectList'}, title: "Projects"},
        {to: "/solutions", title: "Solutions"},
        {to: "/services", title: "Services"}
      ],
      navigationDrawerTabs: [
        {to: "/about", title: "About", iconPrefix: 'far', iconName: "comment-dots"},
        {to: {name: 'ProjectList'}, title: "Projects", iconPrefix: 'fas', iconName: "cubes"},
        {to: "/solutions", title: "Solutions", iconPrefix: 'fab', iconName: "creative-commons-share"},
        {to: "/services", title: "Services", iconPrefix: 'far', iconName: "comment-dots"},
        {to: "/blog", title: "Blog", iconPrefix: 'fab', iconName: "blogger-b"},
        {to: "/protocols", title: "Protocols", iconPrefix: 'fas', iconName: "clipboard-list"},
        {to: "/partners", title: "Partners", iconPrefix: 'far', iconName: "handshake"}
      ],
      window: {width: 0},
      navigationDrawer: false,
      userDetailsPopover: false,
      websiteLogoSmallDevices: false,
      mainNavigationBarRightSideDropdown: false,
      mainNavigationSearchField: true,
      mainNavigationBarHeight: 80,
      userProfileAvatarSize: 38,
      loginRedirect: null,
    }
  },

  computed: {
    ...mapGetters({
      isAuthenticated: 'user/auth/isAuthenticated',
      userData: 'user/profile/sessionData',
      avatar: 'user/profile/avatar/image',
      imagePresent: 'user/profile/avatar/imagePresent',
      displayName: 'user/profile/displayName',
      myMemberships: 'user/profile/membershipArray',
      isAdmin: "user/profile/isAdmin",
    }),
    projectsPublished: function () {
      return this.myMemberships.filter(function (item) {
        return item.projectState === PROJECT_STATE_PUBLISHED
      })
    },
    projectsDraft: function () {
      return this.myMemberships.filter(function (item) {
        return item.projectState === PROJECT_STATE_DRAFT
      })
    },
    currentRouteName() {
      return this.$route.fullPath;
    },
  },

  methods: {
    ...mapActions({
      retrieve: 'user/profile/fetchSession',
    }),

    openCitSciHelp() {
      let supportForm = this.supportFormURL + '?usp=pp_url&entry.630403450=https://citsci.org' + this.currentRouteName
      window.open(supportForm, "_blank")
    },

    handleResize() {
      this.window.width = window.innerWidth
      console.log('window width', this.window.width)
      if (this.window.width >= 960) {
        this.userDetailsPopover = false
      } else {
        this.mainNavigationBarRightSideDropdown = false
      }
      if (this.window.width >= 1264) {
        this.navigationDrawer = false
      }
      if (this.window.width <= 600) {
        this.mainNavigationSearchField = false
        this.websiteLogoSmallDevices = true
        this.mainNavigationBarHeight = 45
        this.userProfileAvatarSize = 28
      } else {
        this.mainNavigationSearchField = true
        this.websiteLogoSmallDevices = false
        this.mainNavigationBarHeight = 80
        this.userProfileAvatarSize = 38
      }
    },

    onCreateClick() {
      // Check if user is verified
      if (JSON.parse(localStorage.getItem('sessionData')) !== null) {
        if (!JSON.parse(localStorage.getItem('sessionData')).isVerified) {
          this.$bvModal.show('not-verified-modal')
        } else {
          this.$router.push({name: 'ProjectCreate'})
        }
      } else {
        this.$router.push({name: 'Login', query: {redirect: '/projects/create'}});
      }
    },

  },

  created() {

    // window.addEventListener('resize', this.handleResize)
    // this.handleResize()

    if (this.$route.fullPath.length > 0 && (this.$route.fullPath !== '/' && this.$route.fullPath.indexOf('404') === -1 && this.$route.fullPath.indexOf('logout') === -1)) {
      this.loginRedirect = {redirect: this.$route.fullPath}
    }
  },

  filters: {
    shortText: function (value) {
      if (value.trim().length < 32) {
        return value;
      } else {
        value = value.substring(0, 31) + "...";
        return value;
      }
    }
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}

</script>

<style scoped lang="scss">
.site-logo {
  min-width: 35px;
  min-height: auto;
}

.dropdown-header {
  color: #22252C !important;
  font-size: 14px;
  font-weight: bold;
  border-bottom: solid 1px #6c757d;
}

.profile-avatar {
  border: 2px solid #FFFFFF;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
  max-width: 100%;
}

</style>

<!-- Unscoped so styles can reach Bootstrap-Vue's dynamically rendered dropdown menu -->
<style lang="scss">
// All navbar dropdowns: scrollable when content overflows
.navbar .dropdown-menu {
  max-height: 70vh;
  overflow-y: auto;
}

// On mobile/collapsed navbar, make the entire nav collapse scrollable
@media (max-width: 767.98px) {
  #nav-collapse {
    max-height: calc(100vh - 56px);
    overflow-y: auto;
  }
}
</style>
